<template>
    <div class="marquee-body" v-show="texts.length > 0">
        <Vue3Marquee :speed="speed" pauseOnHover>
            <div v-for="(text, index) in texts.concat(texts)" :key="index" class="item">
                {{ text }}
            </div>
        </Vue3Marquee>
    </div>
</template>

<script setup lang="ts">
import { fetchGetMyNoticeListAsync } from "@/typescript/Services/Api/NoticeApi";
import { ref, onMounted, onUnmounted } from "vue";
const texts = ref<string[]>([]);
const speed = ref<number>(40);
/**
 * 加载数据
 */
function LoadDataAsync() {
    fetchGetMyNoticeListAsync().then(resp => {
        if (resp.CheckIsOk(false)) {
            texts.value.splice(0);
            const list = resp.data!;
            list.forEach(v => {
                texts.value.push(v.Content!);
            });
        }
    })
}

onMounted(() => {
    /**
     * 加载数据
     */
    LoadDataAsync();

});

onUnmounted(() => {
});

defineExpose({
    LoadDataAsync
});

</script>

<style scoped lang="scss">
.marquee-body {
    width: 100%;
    background: linear-gradient(102deg, rgba(5, 160, 217, 0.55) 0%, rgba(5, 160, 217, 0.25) 100%);
    padding: 3px 0px;
    font-size: 12px;

    .item {
        margin-right: 10%;
    }
}
</style>